
export interface ThemeState {
    theme: string;
  }

export const SET_THEME = "SET_THEME";

type AcceptedTypes = typeof SET_THEME;

export interface ThemeAction {
    type: AcceptedTypes;
    payload: ThemeState | string ;
}

export type ThemeActionTypes = ThemeAction;
